'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chainPropTypes = require('./chainPropTypes.js');
var deepmerge = require('./deepmerge.js');
var elementAcceptingRef = require('./elementAcceptingRef.js');
var elementTypeAcceptingRef = require('./elementTypeAcceptingRef.js');
var exactProp = require('./exactProp.js');
var getDisplayName = require('./getDisplayName.js');
var HTMLElementType = require('./HTMLElementType.js');
var ponyfillGlobal = require('./ponyfillGlobal.js');
var refType = require('./refType.js');

/** @license Material-UI v4.9.12
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

exports.chainPropTypes = chainPropTypes;
exports.deepmerge = deepmerge["default"];
exports.elementAcceptingRef = elementAcceptingRef;
exports.elementTypeAcceptingRef = elementTypeAcceptingRef;
exports.exactProp = exactProp["default"];
exports.getDisplayName = getDisplayName["default"];
exports.HTMLElementType = HTMLElementType;
exports.ponyfillGlobal = ponyfillGlobal;
exports.refType = refType;
